export const THREEWAY_STATE_EXCLUDE = 0;
export const THREEWAY_STATE_INCLUDE = 1;
export const THREEWAY_STATE_ONLY = -1;
